<template>
  <div class="Platform">
    <div class="tms setwidth" >
        <img class="image" src="./TMS/tms.png" alt="">
    </div>
    <div class="box">
        <img src="./TMS/box.png" alt="">
    </div>
    <!-- <div class="tmstitle setwidth" >
        <img src="./TMS/tmstitle.png" alt="">
    </div>
    <div  class="tmstext setwidth">
        <div class="tmstextn">
            企业在<span>运输管理</span>方面存在的问题
        </div>
    </div>
    <div class="tmsF setwidth" >
        <div class="tmsimg">
            <img class="image" src="./TMS/tmsF.png" alt="">
        </div>
    </div>
    <div class="tmstext setwidth">
        <div class="tmstextn">
            时空TMS助您实现<span>运输管理全流程</span>
        </div>
    </div>
    <div class="tmsF setwidth" >
        <div class="tmsimg">
          <img class="image" src="./TMS/tmsS.png" alt="">
        </div>
    </div>
    <div class="tmsF setwidth" >
        <div class="tmsimg">
        <img class="image" src="./TMS/tmsT.png" alt="">
        </div>
    </div>
    <div class="tmstext setwidth">
            <span  class="tmsbot">TMS全流程管理</span>
    </div> -->
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.box{
    width: 1260px*$sun;
    height: 2051px*$sun;
    margin: 20px*$sun auto;
    img{
        width: 100%;
        height: 100%;
    }
}
.Platform{
    // display: flex;
    // justify-content: center;
    // flex-direction: column;
    background-color: #FFFFFF;
    .setwidth{
        width: 100%;
    }
    .tms{
        height: 460px*$sun;
    }
    .tmstitle{
        display: flex;
        justify-content: center;
        padding: 50px*$sun*$sun 0 40px*$sun 0;
    }
    .tmstext{
        display: flex;
        justify-content: center;
        .tmstextn{
            width: 1200px*$sun;
            color: #000000;
            font-size: 28px*$sun;
            font-weight: 500;
            span{
                color: #FF0000;
            }
        }
        .tmsbot{
            font-size: 28px*$sun;
            font-weight: 500;
            color: #FF0000;
            height: 34px*$sun;
            padding-bottom: 62px*$sun;
        }
    }
    .tmsF{
        display: flex;
        justify-content: center;
        padding: 40px*$sun 0;
        .tmsimg{
            width: 1200px*$sun;
        }
    }
}
.image{
    width: 100%;
    height: 100%;
}

</style>
